import React, { useState, useEffect } from 'react';
import * as Request from './request';
import * as CONST from './const';

export const getSearchByKey = (key, search = window.location.search) => {
	if(!search) return '';

	const _search = search.slice(1);
	const _searchArr = _search.split('&');
	const _map = {};
	_searchArr.map(item => {
		const _item = item.split('=');
		if(_item[0] && _item[1]) {
			_map[_item[0]] = _item[1];
		}
	});
	return _map[key] || '';
};

export const setTitle = (title = '数据监控系统') => {
	if(document) {
		document.title = title;
	}
};

// loading
export const loading = {
	show: () => {
		document.getElementById('loading').style.display = 'block';
	},
	hide: () => {
		document.getElementById('loading').style.display = 'none';
	}
};

// toast
export const toast = {
	show: (txt) => {
		const $toast = document.getElementById('toast');
		$toast.style.display = 'block';
		$toast.innerText = txt;
	},
	hide: () => {
		const $toast = document.getElementById('toast');
		$toast.style.display = 'none';
		$toast.innerText = '';
	}
};

export const getUA = () => {
	if(!window || !window.navigator || !window.navigator.userAgent){
		return null;
	}

	const ua = window.navigator.userAgent.toLocaleLowerCase();

	return {
		ua,
		isInWechat: ua.indexOf('micromessenger') > -1,
		isInRongMeiApp: ua.indexOf('rongmeiapp/qingpu') > -1 || ua.indexOf('rongmeiapp') > -1,    // mainly for QingPu
		isIOS: ua.indexOf("iphone") > -1 || ua.indexOf("ios") > -1,
		isAndroid: ua.indexOf("android") > -1 || ua.indexOf("linux") > -1
	}
};

export const _alert = (txt) => {
	if(!txt) return;

	toast.show(txt);

	setTimeout(() => {
		toast.hide();
	}, 2000);
};

/**
 * 登录功能
 * 微信内：微信登录
 * APP 内：暂时先 return
 */
const _user = {
	getInfo: () => {
		const userInfoStr = window.sessionStorage.getItem('_user');
		return userInfoStr && typeof userInfoStr == 'string' ? JSON.parse(userInfoStr) : userInfoStr;
	},
	setInfo: (info = {}) => {
		window.sessionStorage.setItem('_user', JSON.stringify(info));
	},
	setMode: (data) => {
		window.sessionStorage.setItem('mode', data);
	},
	setType: (data) => {
		window.sessionStorage.setItem('type',data);
	},
	setTypeName: (data) => {
		window.sessionStorage.setItem('typename', data);
	},
	
	login: async () => {

	},
	isLogin: () => {
		const userInfo = _user.getInfo();
		return userInfo && userInfo.id;
	},
	_wxRedirectUriReset: (uri = window.location.href)=>{
		let hash, pureUri, pureUrl;
		hash = uri.split('#')[1];
		pureUri = uri.split('#')[0];
		pureUrl = pureUri.split('?')[0];

		let querys = (function (querys) {
			if(!querys) return {};
			let query = {};
			let _querysArr = querys.split('&');
			for(let i=0, len=_querysArr.length; i<len; i++){
				let qItem = _querysArr[i].split('=');
				query[qItem[0]] = qItem[1];
			}
			return query;
		})(pureUri.split('?')[1]);

		let queryArr = [];
		for(let i in querys){
			if(querys[i] && i != 'code' && i != 'state'){
				queryArr.push(i + '=' + querys[i]);
			}
		}
		if(queryArr.length > 0){
			pureUrl += '?' + queryArr.join('&')
		}
		if(!!hash) pureUrl += '#' + hash;

		return pureUrl;
	},
	//首页调用的微信登陆功能----Utils.user.wxLogin({}, () => window.location.reload());
	wxLogin: async (option = {}, callback) => {
		const _userInfo = _user.getInfo();
		if(_userInfo && _userInfo.nickname) return;

		//非微信浏览器：跳过微信授权，使用本地设备号生成游客身份，保证页面在任意浏览器都可以正常打开
		if(!getUA().isInWechat) {
			if(!window.sessionStorage.getItem('openid')) {
				let guestOpenid = window.localStorage.getItem('guest_openid');
				if(!guestOpenid) {
					guestOpenid = 'guest_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
					window.localStorage.setItem('guest_openid', guestOpenid);
				}
				window.sessionStorage.setItem('openid', guestOpenid);
				callback && callback();
			}
			return;
		}

		const code = getSearchByKey('code');
		const state = getSearchByKey('state');
		if(!code) {
			const url = `https://open.weixin.qq.com/connect/oauth2/authorize?${[
				`appid=${CONST.appId}`,
				`redirect_uri=${encodeURIComponent(_user._wxRedirectUriReset(window.location.href))}`,
				`response_type=code`,
				`scope=snsapi_base`,
				`state=STATE_BASE`
			].join('&')}#wechat_redirect`;
			window.location.replace(url);
			return;
		}

		const result = await Request.post({
			hideError: true,
			url: '/user/wx-login',
			data: { code, scope: ({ 'STATE_BASE': 'snsapi_base', 'STATE_USERINFO': 'snsapi_userinfo' })[state] }
		});
		console.log('result', result);
		if(!result) return;

		if(result && result.data) {
			const token = result.data.token;
			window.sessionStorage.setItem('token', token);
			delete result.data.token;
			const userInfo = result.data;
			window.sessionStorage.setItem('openid', userInfo.openid);
			_user.setInfo(userInfo);

			if(!userInfo.nickname) {
				const url = `https://open.weixin.qq.com/connect/oauth2/authorize?${[
					`appid=${CONST.appId}`,
					`redirect_uri=${encodeURIComponent(_user._wxRedirectUriReset(window.location.href))}`,
					`response_type=code`,
					`scope=snsapi_userinfo`,
					`state=STATE_USERINFO`
				].join('&')}#wechat_redirect`;
				window.location.replace(url);
				return;
			}
		}

		setTimeout(() => {
			callback && callback();
		}, 666);
	},
	wxsign: async () => {
		const result = await Request.get({
			url: '/user/wxsign',
			data: {
				url: encodeURIComponent(window.location.href.split('#')[0])
			}
		});
		console.log('wxsign result', result);
		if(!result) return;

		window.wx.config({
			// debug: true,
			...result.data,
			jsApiList: [
				'startRecord',
				'stopRecord',
				'onVoiceRecordEnd',
				'playVoice',
				'pauseVoice',
				'stopVoice',
				'onVoicePlayEnd',
				'uploadVoice',
			] // 必填，需要使用的JS接口列表
		})
	}
};
export const user = _user;

export const arrayToMap = (arr = [], key = 'id', value = 'label') => {
	const map = {};
	arr.map(a => {
		map[a[key]] = a[value];
	});
	return map;
};

export const getBase64 = (img, callback) => {
	const reader = new FileReader();
	reader.addEventListener('load', () => callback(reader.result));
	reader.readAsDataURL(img);
};

export const uploadHelper = {
	submitHandle: (fileList) => {
		const _fileList = [];
		fileList.map(fileInfo => {
			if(fileInfo.response && fileInfo.response.ok == 0 && fileInfo.response.data && fileInfo.response.data.src) {
				_fileList.push(fileInfo.response.data.src);
			}else if(fileInfo.src) {
				_fileList.push(fileInfo.src);
			}
		});
		return JSON.stringify(_fileList);
	},
	editDisplayHandle: (fileListStr) => {
		const _fileList = [];
		const _fileListStr = JSON.parse(fileListStr);
		if(_fileListStr && _fileListStr.length > 0) {
			_fileListStr.map((file, idx) => {
				const fileInfo = file.split('/') && file.split('/')[2] || '';
				if(fileInfo) {
					const [ name, suffix ] = fileInfo.split('.');
					const [ fileName ] = name.split('-');
					_fileList.push({
						uid: idx,
						name: fileName,
						status: 'done',
						url: CONST.imgPrefix + file,
						src: file
					});
				}
			})
		}
		return _fileList;
	}
};

export const niceStr = str => {
	if(!str) return '';
	str = str.replace(/[0-9]+-/ig, '').replace(/\.jpg/ig, '').replace(/\.png/ig, '');
	return str;
};

export const beautyTableColunm = (conf = {}) => {
	const childrenRender = conf.children || null;
	delete conf.children;

	return {
		width: 420,
		render: (text, record, index) => {
			const style = { maxHeight: 88, overflow: 'auto' }
			if(childrenRender && typeof childrenRender == 'function') {
				return (
					<div style={style}>{ childrenRender(record)}</div>
				)
			}else{
				text = text ? text.replace(/\n/ig, '<br />') : text;
				return (
					<div style={style} dangerouslySetInnerHTML={{ __html: text }} />
				)
			}
		},
		...conf
	}
};
